import React, {type JSX} from 'react';
import {styled} from '@mui/material/styles';
import {FormHelperText, type FormHelperTextProps} from '@mui/material';

type Props = {
  shrink?: boolean;
} & FormHelperTextProps;

export function HelperText({
  shrink: _shrink,
  ...props
}: Readonly<Props>): JSX.Element {
  return <FormHelperText {...props} />;
}

export const InputHelperText = styled(HelperText)<Props>(({shrink}) => ({
  ...(shrink && {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  }),
}));
